import ouiBase from '@goldwasserexchange/oui';
import { getOblEndDateWithPerpetual } from '../../../../shared/utils/getOblEndDateWithPerpetual';
import { useBondListTransformApiBySAccId } from '../api';

export const useBondListSAccOblEndDate = () => {
  const sAccId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useBondListTransformApiBySAccId({
    sAccId,
    transformFunction: getOblEndDateWithPerpetual,
  });
  return response;
};
